import type { Taxas } from 'Model/ITaxa.ts'

export type TaxaOption = {
  value: Taxas
  label: string
  disabled: boolean
}

export const taxaOptions: TaxaOption[] = [
  {
    value: 'CO1_ANIMAL',
    label: 'CO1 - Animal',
    disabled: false
  },
  {
    value: '_16S_BACTERIA',
    label: '16S - Bacteria',
    disabled: false
  },
  {
    value: '16S_VERTEBRATES',
    label: '16S - Vertebrates',
    disabled: false
  },
  {
    value: 'FITS2_FUNGAL',
    label: 'FITS2 - Fungal',
    disabled: false
  },
  {
    value: 'PITS2_PLANT',
    label: 'PITS2 - Plant',
    disabled: false
  },
  {
    value: '12S_FISH',
    label: '12S - Vertebrates',
    disabled: false
  },
  {
    value: 'OTHER',
    label: 'Other',
    disabled: false
  }
]
